<template>
  <div class="privacy-policies u-full-width u-full-vp-height u-overflow-x-hidden">
    <div class="u-wrapper-panel">
      <div class="u-row u-top u-full-height">
        <div class="u-w1of12 u-pad-x-md u-pad-t-md u-marg-t-md u-none--sm">
          <div class="u-relative">
            <img class="privacy-policies__pompidou-large u-full-width" src="/images/pompidou.png">
          </div>
        </div>
        <div class="u-marg-l-10of12 u-w1of12 u-relative u-pad-t-md u-none--sm">
          <img class="privacy-policies__pompidou u-full-width" src="/images/pompidou-2.png">
        </div>  
      </div>
    </div>


    <div class="themes__content u-wrapper-panel u-row u-middle u-w8of12 u-pad-l-lg ">

      <div class="t-text--big">

        <h1>Politique de confidentialité et de gestion des données personnelles</h1>

        <h3>Centre Pompidou - Mis à jour le 20 mars 2020</h3>

        <p>Le centre national d'art et de culture Centre Pompidou ne collecte aucune donnée à caractère personnel sur son application.</p>

        <p>Cependant si vous avez téléchargé cette dernière en passant par un magasin d'application en ligne, nous vous recommandons de consulter leur politique de confidentialité pour comprendre quelles données à caractère personnel qu'ils récoltent et la manière dont ils les traitent. Ce sont ces données auxquelles le Centre Pompidou aura ensuite accès :</p>

        <p>
          <external-link :href="'https://policies.google.com/privacy?hl=fr-CA'" target="_blank" class="t-regular">Politique de confidentialité Google</external-link>
        </p>


        <p>
          <external-link :href="'https://www.apple.com/fr/privacy/'" target="_blank" class="t-regular">Politique de confidentialité Apple</external-link>
        </p>
        <p>
          <external-link :href="'https://store.steampowered.com/privacy_agreement/french/'" target="_blank" class="t-regular">Politique de confidentialité Steam</external-link>
        </p>
        
      </div>

    </div>


  </div>
</template>

<script>

import Cta from '@/components/common/Cta'
import CustomCursor from '@/components/CustomCursor'
import ExternalLink from '@/components/common/ExternalLink'

export default {
  name: 'privacy-policies',

  components: {
    CustomCursor,
    Cta,
    ExternalLink
  }

}

</script>

<style lang="stylus">
.privacy-policies
  h1
    line-height 1.1em

  &__pompidou
    transform translateX(-50%)
  
  &__pompidou-large 
    max-width 70px
    position fixed
    z-index 1
    left 10px
</style>
